import { Customer, CustomersGetManyRequest, Page } from '../../../../types'
import { HttpClientConfig } from '../../../useHttpClientConfig'
import { applySearchParams, responseToPage, urlToPathnameAndSearch } from '../../appointments/utils'
import { apiVersion, service } from '../service'

const pathname = `/api/${apiVersion}/customers`

const makeGetCustomers =
  (baseUrl: string, config: HttpClientConfig) =>
  async (request: CustomersGetManyRequest = {}): Promise<Page<Customer>> => {
    const url = new URL(pathname, baseUrl)

    applySearchParams(url, request as Record<string, string>)

    const pathnameAndSearch = urlToPathnameAndSearch(url)
    const response = await service(baseUrl).get(pathnameAndSearch, config)

    return responseToPage<Customer>(response)
  }

export { makeGetCustomers }
